import * as fromBrand from '../actions/brand.action';
import {Brand} from '../../brand';

export interface BrandState {
  entities: Brand[];
  entity?: Brand;
  brandManagers: Brand[];
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  entities: null,
  entity: null,
  loading: false,
  loaded: true,
  error: null,
  brandManagers: null,
};

export function reducer(state = initialState, action: fromBrand.BrandAction): BrandState {
  switch (action.type) {
    case fromBrand.GET_ALL_BRANDS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromBrand.GET_ALL_BRANDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
        error: null
      };
    }
    case fromBrand.GET_ALL_BRANDS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromBrand.GET_BRAND: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromBrand.GET_BRAND_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entity: action.payload,
        error: null
      };
    }
    case fromBrand.GET_BRAND_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: null,
        entity: null,
        error: action.payload
      };
    }
    case fromBrand.ADD_BRAND: {
      return {
        ...state,
        entity: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromBrand.ADD_BRAND_SUCCESS: {
      return {
        ...state,
        entity: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromBrand.ADD_BRAND_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
    case fromBrand.UPDATE_BRAND_SUCCESS: {
      return {
        ...state,
        entity: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromBrand.UPDATE_BRAND: {
      return {
        ...state,
        entity: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromBrand.UPDATE_BRAND_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
    case fromBrand.GET_BRAND_MANAGERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromBrand.GET_BRAND_MANAGERS_SUCCESS: {
      return {
        ...state,
        brandManagers: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromBrand.GET_BRAND_MANAGERS_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
  }
  return state;
}

export const getBrands = (state: BrandState) => state.entities;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/reducers/brand.reducer.ts